import { useEffect } from 'react';

const VERSION_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function useVersionCheck() {
  useEffect(() => {
    if (import.meta.env.DEV) {
      // Skip version checking in development
      return;
    }

    let currentVersion: string | null = null;

    const checkVersion = async () => {
      try {
        // Fetch with cache busting query param
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-cache'
        });
        
        if (!response.ok) return;
        
        const data = await response.json();
        
        if (currentVersion === null) {
          // First load, just store the version
          currentVersion = data.version;
        } else if (currentVersion !== data.version) {
          // Version has changed, notify user
          const shouldReload = window.confirm(
            'A new version of Clubhouse FM is available. Would you like to refresh to get the latest updates?'
          );
          
          if (shouldReload) {
            window.location.reload();
          }
        }
      } catch (error) {
        console.error('Version check failed:', error);
      }
    };

    // Check immediately
    checkVersion();

    // Check periodically
    const interval = setInterval(checkVersion, VERSION_CHECK_INTERVAL);

    // Also check when window regains focus
    const handleFocus = () => {
      checkVersion();
    };
    
    window.addEventListener('focus', handleFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);
}